
import {
  Vue, Component,
} from 'vue-property-decorator';
import LeadTaskStatus from '@/components/LeadTaskStatus.vue';
import {
  ChildTasks, Lead, ProjectsPool, Task, User,
} from '@/types';

@Component({
  components: {
    LeadTaskStatus,
  },
})
export default class LeadWorkflowTasks extends Vue {
  get pool(): ProjectsPool {
    return this.$store.getters.currentPool;
  }

  get infoPool(): ProjectsPool {
    return this.$store.getters.currentInfoPool;
  }

  get currentLead(): Lead {
    return this.$store.getters.currentLead;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  // @Watch('currentLead')
  // onCurrentProject(val: Lead) {
  //   console.log('LeadWorkflowTasks: onCurrentProject()'); // eslint-disable-line no-console
  //   if (val) {
  //     this.initLead();
  //   }
  // }

  get lead(): Lead | null {
    // Se è una figlia...
    if (this.currentLead
      && ['installatore-figlia', 'elettrica-figlia', 'termica-figlia'].includes(this.currentLead.type)) {
      let fatherLead: Lead | null = null;
      if (this.currentLead.Tasks.length > 0) {
        const { fatherLeadId } = this.currentLead.Tasks[0];
        fatherLead = fatherLeadId
          && fatherLeadId in this.pool
          && this.pool[fatherLeadId]
          ? this.pool[fatherLeadId]
          : null;
      }

      if (fatherLead && 'allowedUsers' in fatherLead && fatherLead.allowedUsers) {
        // Se l'utente ha il permesso di visualizzarla,
        // utilizza il padre
        const allowed = this.isSuperUser
          || fatherLead.allowedUsers.includes(`:${this.user.id}:`);

        if (allowed) {
          return fatherLead;
        }
      }
    }

    return this.currentLead;
  }

  get version() {
    return this.lead && 'version' in this.lead && this.lead.version ? Number(this.lead.version) : null;
  }

  get childTasks(): ChildTasks {
    if (!this.lead || this.version !== 3) return {};

    const childTasksObj: ChildTasks = {};

    this.lead.Tasks.forEach((lt: Task) => {
      if (lt.relationship === 'father') {
        // Recupera il task della figlia (verrà inserito nella struttura
        // per potere usare le sue informazioni di stato dei task
        // e non quelle del padre perché potrebbero essere disabilitati
        // se la lead è stata chiusa).
        const childTask = this.getChildTask(lt);

        const count = lt.childCount ? lt.childCount : 1;
        if (count in childTasksObj) {
          childTasksObj[count].push(childTask);
        } else {
          childTasksObj[count] = [childTask];
        }
      }
    });

    return childTasksObj;
  }

  getChildTask(task: Task) {
    const childLead = task.childLeadId
      && task.childLeadId in this.pool
      && this.pool[task.childLeadId]
      ? this.pool[task.childLeadId]
      : null;

    let childTask: Task | null = null;
    if (childLead) {
      childTask = childLead.Tasks.find((t) => t.name === task.name) ?? null;
    }

    // Se non è stato possibile recuperare il task corrispondente nella
    // lead figlia, utilizza quello del padre.
    return childTask ?? task;
  }

  hasChildren() {
    return Object.keys(this.childTasks).length > 0;
  }

  childId(child: Task[]): number | null {
    const task = child && 0 in child ? child[0] : null;

    if (!task) return null;

    const property = task?.relationship === 'father' ? 'childLeadId' : 'LeadId';

    return property in task
      && Boolean(task[property])
      ? task[property]
      : null;
  }

  childClass(child: Task[]) {
    const childId = this.childId(child);
    if (child === null) return '';

    const lead = childId && childId in this.infoPool && this.infoPool[childId]
      ? this.infoPool[childId]
      : null;

    return lead?.status || '';
  }
}
